import React, { useState, useEffect, useRef } from "react";
import { PieChart } from "react-minimal-pie-chart";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { DataLayerEvent } from "../services/lsq";
import {
  formStartEvent,
  formSuccessEvent,
  formAbandonmentEvent,
} from "../services/adobeDataLayer.js";

ChartJS.register(ArcElement, Tooltip, Legend);
function Cal1() {
  let resultsGlobalRef = useRef({
    payment: 504541,
    total: 60544901,
    totalinterest: 20544901,
    principalAmountDisplay: "40,000,000",
  });

  const [results, setResults] = useState(resultsGlobalRef.current);

  const [avalue, setAvalue] = useState(66.067);
  const [bvalue, setBvalue] = useState(33.93);
  const [inputs, setInputs] = useState({
    loanAmount: 40000000,
    interestRate: 9,
    years: 10,
    tenureType: "year", // Added tenureType state
  });

  const hasTriggeredFormStart = useRef(false);
  let lastAccessedField = "na";

  useEffect(() => {
      const handleBeforeUnload = (event) => {
        // console.log("calculator form started: ", hasTriggeredFormStart.current);
        // Custom logic to be executed before tab or window is closed
        if (hasTriggeredFormStart.current) {
          formAbandonmentEvent(
            "LAP calculator",
            "calculator",
            lastAccessedField,
            "calculate emi"
          );
          console.table(window.adobeDataLayer);
        }
      };
  
      window.addEventListener("beforeunload", handleBeforeUnload);
      //Clean Up
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, []);

  // useEffect(() => {
  //   Calculate(inputs);
  // }, [inputs]);

  const handleChange = (event) => {
    handleFormStart();
    let name = event.target.name;
    let value = event.target.value;
    if (name === "loanAmount") {
      value = parseInt(value);
    } else if (name === "interestRate") {
      value = parseFloat(value);
    }
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  const handleFormStart = () => {
      if (!hasTriggeredFormStart.current) {
        formStartEvent("LAP calculator", "calculator", "calculate emi");
        hasTriggeredFormStart.current = true;
      }
    };

  function Calculate() {
    let params = inputs;
    if (!params.loanAmount || !params.interestRate || !params.years) {
      return false;
    }
    let finalAmount = parseFloat(params.loanAmount);

    if (finalAmount !== "") {
      let principal = parseFloat(finalAmount);

      let interest = parseFloat(params.interestRate) / 100 / 12;
      let payments = parseFloat(params.years) * 12;

      // if (params.tenureType === "month") {
      //   payments = parseFloat(params.years);
      // }

      let x = Math.pow(1 + interest, payments); //Math.pow computes powers
      let monthly = (principal * x * interest) / (x - 1);

      if (isFinite(monthly) && principal < 1000000000) {
        let payment = monthly
          .toFixed(0)
          .toLocaleString(navigator.language, { minimumFractionDigits: 0 });

        let total = (monthly * payments)
          .toFixed(0)
          .toLocaleString(navigator.language, { minimumFractionDigits: 0 });

        let totalinterest = (monthly * payments - principal)
          .toFixed(0)
          .toLocaleString(navigator.language, { minimumFractionDigits: 0 });

        let principalAmountDisplay = finalAmount.toLocaleString(
          navigator.language,
          { minimumFractionDigits: 0 }
        );

        resultsGlobalRef.current.payment = payment;
        resultsGlobalRef.current.principalAmountDisplay =
          principalAmountDisplay;
        resultsGlobalRef.current.total = total;
        resultsGlobalRef.current.totalinterest = totalinterest;

        setResults({ ...resultsGlobalRef.current });

        var a = (principal / total) * 100;
        var b = (totalinterest / total) * 100;
        setAvalue(a);
        setBvalue(b);

        // console.log("avalue", avalue, principal);
        // console.log("bvalue", bvalue);
      } else {
        setResults({
          payment: "",
          total: "",
          totalinterest: "",
          principalAmountDisplay: "",
        });
      }
    }
  }

  const handleApplyForLoan = () => {
    Calculate(); // Call Calculate function to perform calculations
  };

  // const toggleTenureType = () => {
  //   setInputs((prevInputs) => ({
  //     ...prevInputs,
  //     tenureType: prevInputs.tenureType === "year" ? "month" : "year",
  //   }));
  // };

  const sliderStyle = {
    position: "absolute",
    left: `${((inputs.loanAmount - 100000) / (100000000 - 100000)) * 100}%`,
    top: "0",
    transform: "translateX(-50%)",
    fontSize: "14px",
    backgroundColor: "#f4f4f4",
    borderRadius: "4px",
    padding: "5px",
  };
  const sliderStyle1 = {
    position: "absolute",
    left: `${((inputs.interestRate - 1) / (20 - 1)) * 100}%`,
    top: "0",
    transform: "translateX(-50%)",
    fontSize: "14px",
    backgroundColor: "#f4f4f4",
    borderRadius: "4px",
    padding: "5px",
  };
  const sliderStyle2 = {
    position: "absolute",
    top: "0",
    left: `${
      ((inputs.years - (inputs.tenureType === "year" ? 1 : 12)) /
        (inputs.tenureType === "year" ? 15 : 180 - 1)) *
      100
    }%`,
    transform: "translateX(-50%)",
    backgroundColor: "#f4f4f4",
    borderRadius: "4px",
    padding: "5px",
  };
  return (
    <>
      <article className="calculator_section">
        <div className="container">
          <div className="calculator_wrapper">
            <h2 className="m-0">LAP Calculator</h2>
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-4 pe-5 col-12">
                <div className="loan_amt align-items-center">
                  <h3>Loan Amount</h3>

                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="range"
                      name="loanAmount"
                      min="100000"
                      max="100000000"
                      step="1000"
                      className="theme-input"
                      value={inputs.loanAmount}
                      onChange={handleChange}
                    />
                    <span className="slider-value value2" style={sliderStyle}>
                      &#8377; {inputs.loanAmount.toLocaleString()}
                    </span>
                    <div className="d-flex justify-content-between">
                      <p>1 L</p>
                      <p>10 Cr</p>
                    </div>
                  </div>
                </div>

                <div className="rate_team align-items-center ">
                  <div className="inerest_rate loan_amt align-items-center ">
                    <h3>
                      Illustrative{" "}
                      <span style={{ color: "#E3530F" }}>Interest Rate</span>{" "}
                      p.a
                    </h3>
                    <div style={{ position: "relative", width: "100%" }}>
                      <input
                        type="range"
                        className="theme-input"
                        name="interestRate"
                        min="1"
                        max="20"
                        step="0.1"
                        value={inputs.interestRate}
                        onChange={handleChange}
                      />
                      <span className="slider-value" style={sliderStyle1}>
                        {inputs.interestRate}%
                      </span>
                      <div className="d-flex justify-content-between">
                        <p>1%</p>
                        <p>20%</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="loan_team loan_amt align-items-center">
                  <h3>
                    Tenure
                    {/* ({inputs.tenureType === "year" ? "Years" : "Months"}) */}
                  </h3>
                  {/* <div className="toggle_tenure">
                    ( <p>Year</p>
                    <label className="switch">
                      <input
                        type="checkbox"
                        onChange={toggleTenureType}
                        checked={inputs.tenureType === "month"}
                      />
                      <span className="slider round"></span>
                    </label>
                    <p>Month</p> )
                  </div> */}

                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="range"
                      className="theme-input"
                      name="years"
                      min={inputs.tenureType === "year" ? "1" : "12"}
                      max={inputs.tenureType === "year" ? "15" : "180"}
                      step={inputs.tenureType === "year" ? "1" : "12"}
                      value={inputs.years}
                      onChange={handleChange}
                    />
                    <span className="slider-value value2" style={sliderStyle2}>
                      {inputs.years}
                      {inputs.tenureType === "year" ? " years" : " months"}
                    </span>
                    {/* <div className="d-flex justify-content-between">
                      <p>12 Month</p>
                      <p>18 Months</p>
                    </div> */}
                    <div className="d-flex justify-content-between">
                      <p>
                        {inputs.tenureType === "year" ? "1 Year" : "12 Months"}
                      </p>
                      <p>
                        {inputs.tenureType === "year"
                          ? "15 Years"
                          : "180 Months"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-12">
                <div className="row  align-items-center emi ps-lg-0 ">
                  <div className="col-6">
                    <div className="d-none d-md-none">
                      <Pie
                        data={{
                          labels: ["Interest Payable", "Principal Amount"],
                          datasets: [
                            {
                              data: [bvalue, avalue],
                              backgroundColor: ["#fff", "#E3530F"],
                              borderColor: ["#fff", "#E3530F"],
                            },
                          ],
                        }}
                        options={{
                          plugins: {
                            legend: {
                              display: false,
                            },
                            tooltip: {
                              callbacks: {
                                label: function (context) {
                                  return false;
                                },
                              },
                            },
                          },
                        }}
                      />
                    </div>
                    <div className="d-block d-md-block">
                      <Doughnut
                        data={{
                          labels: ["Interest Payable", "Principal Amount"],
                          datasets: [
                            {
                              data: [bvalue, avalue],
                              backgroundColor: ["#fff", "#E3530F"],
                              borderColor: ["#fff", "#E3530F"],
                            },
                          ],
                        }}
                        options={{
                          plugins: {
                            legend: {
                              display: false,
                            },
                            tooltip: {
                              callbacks: {
                                label: function (context) {
                                  return false;
                                },
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-6">
                    <div>
                      <div className="row">
                        <div className="col-12 p-0 my-2">
                          <h3
                            className="font-bold d-flex align-items-center"
                            style={{ color: "#E3530F" }}
                          >
                            <span className="orangebox me-1"></span>Principal
                            Amount
                          </h3>
                          <p className="output">
                            &#8377;{" "}
                            <span
                              id="principalAmountDisplay"
                              style={{ fontWeight: "bolder" }}
                            >
                              {results.principalAmountDisplay}
                            </span>
                          </p>
                        </div>
                        <div className="col-12 p-0 my-2 ">
                          <h3
                            className="font-bold d-flex align-items-center"
                            style={{ color: "#E3530F" }}
                          >
                            <span className="whitebox me-1"></span>Interest
                            Payable
                          </h3>
                          <p className="output">
                            &#8377;{" "}
                            <span
                              id="totalinterest"
                              style={{ fontWeight: "bolder" }}
                            >
                              {results.totalinterest > 0
                                ? parseInt(
                                    results.totalinterest
                                  ).toLocaleString("en-IN")
                                : ""}
                            </span>
                          </p>
                        </div>

                        <div className="col-12 p-0 my-2">
                          <h3
                            className="font-bold"
                            style={{ color: "#B02A30" }}
                          >
                            Total Payment
                          </h3>
                          <p className="output">
                            &#8377;{" "}
                            <span
                              id="totalemi"
                              style={{ fontWeight: "bolder" }}
                            >
                              {results.total > 0
                                ? parseInt(results.total).toLocaleString(
                                    "en-IN"
                                  )
                                : ""}
                            </span>
                          </p>
                        </div>

                        <div className="d-md-block d-none col-12 p-0 my-2">
                          <button className="applyloanbtn">
                            <p className="output m-0">
                              Your Montly EMI is &#8377;
                              <span id="payment1">
                                {results.payment > 0
                                  ? parseInt(results.payment).toLocaleString(
                                      "en-IN"
                                    )
                                  : ""}
                              </span>
                            </p>
                          </button>
                        </div>
                        <div className="d-md-block d-none p-0">
                          <div>
                            <button
                              className="calculate_btn"
                              onClick={() => {
                                handleApplyForLoan();
                                DataLayerEvent(
                                  "",
                                  "",
                                  "custom_event",
                                  "lap_campaign",
                                  "lap_calculater",
                                  "calculate_clicked",
                                  false
                                );
                                handleFormStart();
                                formSuccessEvent("LAP calculator", {...inputs, interestPayable:resultsGlobalRef.current.totalinterest, totalPayment:resultsGlobalRef.current.total, monthlyEMI:resultsGlobalRef.current.payment,}, "calculator", "calculate emi", false);
                              }}
                            >
                              Calculate
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="my-3 d-md-block d-none p-0">
                        <p className="note">
                          Note: Actual amount might differ based on your
                          eligibility.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-md-none d-block col-12 p-0 my-2">
                    <button className="applyloanbtn">
                      <p className="output m-0">
                        Your Montly EMI is &#8377;
                        <span id="payment1">
                          {results.payment > 0
                            ? parseInt(results.payment).toLocaleString("en-IN")
                            : ""}
                        </span>
                      </p>
                    </button>
                  </div>
                  <div className="d-md-none d-block p-0">
                    <div>
                      <button
                        className="calculate_btn"
                        onClick={() => {
                          handleApplyForLoan();
                          DataLayerEvent(
                            "",
                            "",
                            "custom_event",
                            "lap_campaign",
                            "lap_calculater",
                            "calculate_clicked",
                            false
                          );
                          handleFormStart();
                          formSuccessEvent("LAP calculator", {...inputs, interestPayable:resultsGlobalRef.current.totalinterest, totalPayment:resultsGlobalRef.current.total, monthlyEMI:resultsGlobalRef.current.payment,}, "calculator", "calculate emi", false);
                        }}
                      >
                        Calculate
                      </button>
                    </div>
                  </div>
                  <div className="col-12 d-md-none d-block">
                    <div className="my-3 p-0">
                      <p className="note">
                        Note: Actual amount might differ based on your
                        eligibility.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default Cal1;
